import React, { useState, useEffect, useRef } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'info', duration = 5000, index = 0, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const timerRef = useRef(null);
  const fadeTimerRef = useRef(null);

  useEffect(() => {
    // Clear any existing timers
    if (timerRef.current) clearTimeout(timerRef.current);
    if (fadeTimerRef.current) clearTimeout(fadeTimerRef.current);

    // Set up auto-close timer
    timerRef.current = setTimeout(() => {
      setIsVisible(false);
      fadeTimerRef.current = setTimeout(() => {
        onClose();
      }, 300); // Wait for fade out animation
    }, duration);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (fadeTimerRef.current) clearTimeout(fadeTimerRef.current);
    };
  }, [duration]); // Remove onClose from dependencies

  const handleClose = () => {
    // Clear auto-close timer
    if (timerRef.current) clearTimeout(timerRef.current);
    
    setIsVisible(false);
    fadeTimerRef.current = setTimeout(() => {
      onClose();
    }, 300);
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  // Calculate position based on index
  const isMobile = window.innerWidth <= 768;
  const topPosition = isMobile ? 10 + (index * 70) : 20 + (index * 80);

  return (
    <div 
      className={`toast toast-${type} ${isVisible ? 'toast-visible' : 'toast-hidden'}`}
      style={{ top: `${topPosition}px` }}
    >
      <div className="toast-content">
        <div className="toast-icon">{getIcon()}</div>
        <div className="toast-message">{message}</div>
        <button className="toast-close" onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;
